import React from "react";
import CardTemplate from "@appsinti/ui-core/CardTemplate";
import { MetricData } from "@appsinti/ui-core/styles";
import StatsPreview from "../../../../../../../interfaces/StatsPreview";
import { CardTitleComponent, CustomRow } from "../../../styles";

const Reservations: React.FC<{ preview: StatsPreview }> = ({ preview }) => {
  return (
    <CardTemplate
      background={"white"}
      noPadding={true}
      header={
        <CustomRow>
          <CardTitleComponent title={"People"} />
          <CardTitleComponent title={"Reserve"} />
        </CustomRow>
      }
      body={
        <CustomRow>
          <div className="column">
            <MetricData size={"bigger"} weight={"bold"}>
              {`${preview.reservationsData.total.customerSeatedCount}/${
                preview.reservationsData.total.customerDoneCount +
                preview.reservationsData.total.customerSeatedCount
              }`}
            </MetricData>
          </div>
          <div className="column">
            <MetricData size={"bigger"} weight={"bold"}>
              {`${preview.reservationsData.total.reservationCount}r / ${preview.reservationsData.total.reservationPeopleCount}p`}
            </MetricData>
          </div>
        </CustomRow>
      }
    />
  );
};

export default Reservations;
